// COMPONENTS
import GameWrapper from "./GameWrapper"
import HeaderPanel from "./HeaderPanel"
import Board from "./Board"
import ButtonPanel from "./ButtonPanel"
import Score from "./Score"
import RestartGame from "./RestartGame"

// CUSTOM HOOKS
import useGame from "../hooks/useGame"
import useGameOver from "../hooks/useGameOver"

// BUILT IN HOOKS
import { useReducer } from "react"

// REDUCER FUNCTION & STATE
import { initialState, handleState } from "../business/jokerState"
import GameRules from "./GameRules"


const Game = () => {

    const [board, setBoard, score, setScore] = useGame()
    const [jokerState, dispatchJokerAction] = useReducer(handleState, JSON.parse(localStorage.getItem("jokerState")) || initialState)
    const [gameOver, setGameOver] = useGameOver(board, jokerState)

    return (
        <GameWrapper gameState={gameOver}>
            <div class="balloon"></div>
    <div class="balloon"></div>
    <div class="balloon"></div>
    <div class="balloon"></div>
    <div class="balloon"></div>
            <HeaderPanel>
                <Score score={score} />
                <ButtonPanel jokers={jokerState} dispatchJokerAction={dispatchJokerAction} />
            </HeaderPanel>
            <Board
                board={board}
                setBoard={setBoard}
                jokers={jokerState}
                dispatchJokerAction={dispatchJokerAction}
                gameOver={gameOver} />
            <div
  style={{
    display: "flex",
    flexDirection: "row", // Или "column", если компоненты должны быть вертикально
    gap: "16px",          // Добавим промежуток между элементами
    alignItems: "center", // Выравнивание элементов по центру (по желанию)
  }}
>
  <RestartGame
    resetBoard={setBoard}
    resetScore={setScore}
    resetJokers={dispatchJokerAction}
    resetGameOver={setGameOver}
  />
  <GameRules resetBoard={setBoard}/>
</div>
        </GameWrapper>
    )
}

export default Game